// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2So6t","form":"styles_form__2_Ieh"};